// import { LOGIN_PATH } from '@/common/main/config';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from '@/common/infrastructure/axios';

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
  const verifyAuthorization = async () => {
    try {
      // Check if session token exists before making API call
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }

      const response = await axios.get('identity/verify-authorization');
      return response.status === 200;
    } catch (error) {
      // Handle authorization errors (401, 403, etc.)
      return false;
    }
  };

    const checkAuthentication = async () => {
      // Check if the URL matches the pattern .../link/{token}
      const linkTokenPattern = /\/link\/[^\/]+$/;
      const isLinkTokenUrl = linkTokenPattern.test(location.pathname);

      const inviteLinkPattern = /\/invite\/[^\/]+$/;
      const isInviteLinkUrl = inviteLinkPattern.test(location.pathname);
      const isDeepLinkUrl = /^\/dl\/appId\/\d+/.test(location.pathname);

      if (isLinkTokenUrl || isInviteLinkUrl || isDeepLinkUrl) {
        return;
      }

      const isAuthorized = await verifyAuthorization();

      if (!isAuthorized) {
        navigate('/login', { replace: true });
      }
    };

    checkAuthentication();
  }, [navigate, location.pathname]);

  return children;
};

export default AuthGuard;
